import { Mail, Download } from "lucide-react";

function Footer() {
  return (
    <footer className="border-t border-white/5 mt-32">
      <div className="max-w-6xl mx-auto px-6 py-12 flex flex-col md:flex-row justify-between items-start md:items-center gap-6 text-sm font-body">

        <div className="text-muted leading-[1.75] select-none cursor-default">
          <p className="text-text font-medium">Siddharth</p>
          <p>© 2026 Siddharth. Built with React, Tailwind CSS & Framer Motion</p>
        </div>

        <div className="flex gap-5 text-muted items-center">
          <a
            href="https://github.com/siddharthriot/"
            target="_blank"
            rel="noreferrer"
            aria-label="GitHub"
            className="hover:text-accent transition select-none cursor-pointer"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 0C5.37 0 0 5.37 0 12c0 5.31 3.435 9.795 8.205 11.385.6.105.825-.255.825-.57 0-.285-.015-1.23-.015-2.235-3.015.555-3.795-.735-4.035-1.41-.135-.345-.72-1.41-1.23-1.695-.42-.225-1.02-.78-.015-.795.945-.015 1.62.87 1.845 1.23 1.08 1.815 2.805 1.305 3.495.99.105-.78.42-1.305.765-1.605-2.67-.3-5.46-1.335-5.46-5.925 0-1.305.465-2.385 1.23-3.225-.12-.3-.54-1.53.12-3.18 0 0 1.005-.315 3.3 1.23.96-.27 1.98-.405 3-.405s2.04.135 3 .405c2.295-1.56 3.3-1.23 3.3-1.23.66 1.65.24 2.88.12 3.18.765.84 1.23 1.905 1.23 3.225 0 4.605-2.805 5.625-5.475 5.925.435.375.81 1.095.81 2.22 0 1.605-.015 2.895-.015 3.3 0 .315.225.69.825.57A12.02 12.02 0 0 0 24 12c0-6.63-5.37-12-12-12z"/>
            </svg>
          </a>

            <a
            href="https://www.linkedin.com/in/siddharthmac/"
            target="_blank"
            rel="noreferrer"
            aria-label="LinkedIn"
            className="hover:text-accent transition select-none cursor-pointer"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/>
              <rect x="2" y="9" width="4" height="12"/>
              <circle cx="4" cy="4" r="2"/>
            </svg>
          </a>

          <a
            href="mailto:siddharthriot@gmail.com"
            aria-label="Email"
            className="hover:text-accent transition select-none cursor-pointer"
          >
            <Mail size={20} />
          </a>

          <a
            href="/Siddharth_Kumar_Resume.pdf"
            download="Siddharth_Kumar_Resume.pdf"
            aria-label="Download Resume"
            className="hover:text-accent transition select-none cursor-pointer flex items-center gap-2 ml-3 px-3 py-1.5 rounded-md border border-white/10 hover:border-accent/30"
            title="Download Resume"
          >
            <Download size={18} />
            <span className="hidden sm:inline text-xs font-semibold">Resume</span>
          </a>
        </div>

      </div>
    </footer>
  );
}

export default Footer;